import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ThirdpartyService {
  constructor(private http: HttpClient) {}

  getAllThirdParties(data) {
    return this.http.post(`${environment.apiUrl}/third-party/all`, data).pipe();
  }

  createThirdParty(data) {
    return this.http
      .post(`${environment.apiUrl}/third-party/create`, data)
      .pipe();
  }

  updateThirdParty(id, data) {
    return this.http
      .patch(`${environment.apiUrl}/third-party/update/${id}`, data)
      .pipe();
  }

  deleteThirdParty(id) {
    return this.http
      .delete(`${environment.apiUrl}/third-party/delete/${id}`)
      .pipe();
  }
}
